type SetActiveOrganization = (params: { organization: string }) => Promise<unknown>;

/** Switch Clerk org only when hire landed in a different org (e.g. guest → portal). */
export async function switchToHireOrganization(
  setActive: SetActiveOrganization | undefined,
  organizationId: string | null | undefined,
  currentOrganizationId: string | null | undefined,
): Promise<void> {
  if (!setActive || !organizationId) return;
  if (currentOrganizationId === organizationId) return;
  try {
    await setActive({ organization: organizationId });
  } catch {
    /* optional — user may already be in org */
  }
}
